import axios from 'axios'
import store from '@/store/index.js'
import JSONbig from 'json-bigint';
import { baseURL,loginUrl } from './baseUrl.js'
import { Message } from 'element-ui'
// 非Vue环境使用
import cache from '@/utils/cache'

const http = {}

axios.defaults.headers.post["Content-Type"] = "application/json";

var instance = axios.create({
	transformResponse: [data => JSONbig.parse(data)],  // 替换原生 JSON.parse  
	// timeout: 20000,
	baseURL,
	validateStatus(status) {
		switch (status) {
			case 400:
				Message.error('请求出错')
				break
			case 401:
				Message.warning({
					message: '授权失败，请重新登录'
				})
				store.commit('LOGIN_OUT')
				setTimeout(() => {
					window.location.reload()
				}, 1000)
				return
			case 403:
				Message.warning({
					message: '拒绝访问'
				})
				break
			case 404:
				Message.warning({
					message: '请求错误,未找到该资源'
				})
				break
			case 500:
				Message.warning({
					message: '服务端错误'
				})
				break
		}
		return status >= 200 && status < 300
	}
})
// instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// 添加请求拦截器
instance.interceptors.request.use(
	function (config) {
		let ssoParam = cache.get('token');
		// 请求头添加token
		if (ssoParam) {
			config.headers.Authorization = "Bearer " + ssoParam;
		}
		return config
	},
	function (error) {
		return Promise.reject(error)
	}
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
	response => {
		// console.log('response',response)
		//response.data  = JSONbig.parse(JSON.stringify(response.data)); 
		return response
	},
	err => {
		if (err && err.response) {
			switch (err.response.status) {
				case 400:
					err.message = '请求出错'
					break
				case 401:
					err.message = '授权失败，请重新登录'
					break
				case 403:
					err.message = '拒绝访问'
					break
				case 404:
					err.message = '请求错误,未找到该资源'
					break
				case 500:
					err.message = '服务端错误'
					break
				case 501:
					err.message = '服务未实现'
					break
				case 502:
					err.message = '网关错误'
					break
				case 503:
					err.message = '服务不可用'
					break
				case 504:
					err.message = '网关超时'
					break
				case 505:
					err.message = 'HTTP版本不受支持'
					break
				default:
			}
		} else {
			err.message = '连接服务器失败'
		}
		// Message.error({
		//     message: err.message
		// })
		return Promise.reject(err.response)
	}
)

http.get = function (url, options) {
	return new Promise((resolve, reject) => {
		instance
			.get(url, {params: options})
			.then(response => {
				//response = response.data;
				//console.log('response',response.status)
				if (response.status == 200) {
					resolve(response.data)
				} else {				
						if(response.status == 301 || response.status == 401 || response.status == 403){
							window.localStorage.setItem('searchOriginLoginMes', '');
							window.localStorage.setItem('ssoParamSearchOrigin', '');
							window.location.href=loginUrl;
							
						} else {
							Message.error({
								message:  response.message
							})
							reject(response.message)
						}
						//reject(response.message)
				}
			})
			.catch(e => {
				console.log(e)
				window.localStorage.setItem('searchOriginLoginMes', '');
				window.localStorage.setItem('ssoParamSearchOrigin', '');
				window.location.href=loginUrl;
			})
	})
}

http.post = function (url, data, options) {
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, options)
			.then(response => {				
				if (response.status == 200) {
					resolve(response.data)
				} else {
					if(response.status == 301 || response.status == 401 || response.status == 403){
						window.localStorage.setItem('searchOriginLoginMes', '');
						window.localStorage.setItem('ssoParamSearchOrigin', '');
						window.location.href=loginUrl;
					} else {
						Message.error({
							message:  response.message
						})
						reject(response.message)
					}
					
				}
			})
			.catch(e => {
				console.log(e)
				window.localStorage.setItem('searchOriginLoginMes', '');
				window.localStorage.setItem('ssoParamSearchOrigin', '');
				window.location.href=loginUrl;
			})
	})
}

http.getBlob = function (url, options) {
	return new Promise((resolve, reject) => {
		instance
			.get(url, {params: options}, {
				responseType:'blob'
			})
			.then(response => {
				if (response) {
					resolve(response.data)
				} else {
					if(response.status == 301 || response.status == 401 || response.status == 403){
						window.localStorage.setItem('searchOriginLoginMes', '');
						window.localStorage.setItem('ssoParamSearchOrigin', '');
						window.location.href=loginUrl;
					} else {
						Message.error({
							message:  response.message
						})
						reject(response.message)
					}
				}
			})
			.catch(e => {
				console.log(e)
			})
	})
}

http.postFile = function (url, data, options) {
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				if (response && response.status == 200) {
					resolve(response.data)
				} else {
					if(response.status == 301 || response.status == 401 || response.status == 403){
						window.localStorage.setItem('searchOriginLoginMes', '');
						window.localStorage.setItem('ssoParamSearchOrigin', '');
						window.location.href=loginUrl;
					} else {
						Message.error({
							message:  response.message
						})
						reject(response.message)
					}
				}
			})
			.catch(e => {
				console.log(e)
			})
	})
}

export default http
